<template>
  <section class="your-tomorrow-is-today">
    <div class="your-tomorrow-is-today__content">
      <div class="your-tomorrow-is-today__text">
        <h3 class="your-tomorrow-is-today__subheading">
          {{ $t('multiteatr.yourTomorrowIsToday.note') }}
        </h3>

        <p
          class="your-tomorrow-is-today__description"
          v-html="$t('multiteatr.yourTomorrowIsToday.terms')"
        />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.your-tomorrow-is-today {
  padding: 5.6rem 1.6rem 3.2rem;

  &__content {
    display: grid;
    gap: 2.4rem;
    max-width: 120rem;
    margin: 0 auto;
  }

  &__heading {
    @include h8;
    margin-bottom: 1.6rem;
    color: $text-400;
  }

  &__subheading {
    @include body-1-medium;
    margin-bottom: 1.6rem;
    color: $text-400;
  }

  &__description {
    @include body-1-medium;
    margin-bottom: 0.8rem;
    color: $text-400;
  }

  &__source {
    @include body-3-medium;
    color: $text-200;
  }

  &__image {
    max-width: 48rem;
    width: 100%;
    border-radius: 2.4rem;
  }
}

@include atM {
  .your-tomorrow-is-today {
    padding: 7.2rem 3.2rem 4rem;

    &__content {
      align-items: center;
      grid-template-columns: 1fr;
    }

    &__heading {
      @include h5;
    }
  }
}
</style>
